import React, { useState, useEffect } from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import payment from "../assets/images/payment.png";
import { getWalletTransactions } from '../services/walletApi';
import { getPaymentHistory } from '../services/ProgramApi';
import { showToast } from '../config/Alert';
import LoadingSpinner from './LoadingSpinner';
import arrowLeft from "../assets/images/arrow-left.png";

const PaymentHistrory = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const source = location.state?.source || 'history';

  // Fetch payment history
  const fetchPaymentHistory = async () => {
    try {
      const response = source === 'wallet'
        ? await getWalletTransactions(user.id)
        : await getPaymentHistory(user.id);
      setTransactions(response.data);
    } catch (error) {
      showToast("Failed to fetch payment history.", 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }
  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>
        <div className='breadcrum bg_light_yellow mb-2'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to='/account'> <img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Payment History</h2>
        </div>
        {/* <h6 className=''>
          <img src={payment} width={20} alt='user' />
          <span className='ps-1'></span>
        </h6> */}
        {transactions.length > 0 ? (
          <ListGroup variant="flush" className='list_group_type_history'>
            {transactions.map((transaction, index) => (
              <ListGroup.Item key={index} className='paymentCard'>
                <p className='mb-0 fs-12'>
                  <span
                    className={`fw-7 me-1 ${transaction.transaction_type === 'credit' ? 'text-success' : 'text-danger'
                      }`}
                  >
                    {transaction.transaction_type === 'credit' ? '+' : '-'}
                  </span>
                  ₹ {transaction.amount} {transaction.description}
                </p>
                <small className='paymentTime fs-10'>
                  {new Date(transaction.created_at).toLocaleTimeString()} |{' '}
                  {new Date(transaction.created_at).toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                  })}
                </small>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <div className='text-center pt-5 mt-5'>
            <h4>No transactions found.</h4>
          </div>
        )}
      </Container>
    </div>
  );
};

export default PaymentHistrory;